import React from "react"


const Navbar = () => {
    return (
        <header id="nav-fixed">
            <a href="#about" className="logo active scroll">パージャンチーノ</a>
            <div className="menu-toggle"></div>
            <nav className="container-nav">
                <ul>
                    <li><a href="#landing" className="active scroll">Home</a></li>
                    <li><a href="#about" className="scroll">About</a></li>
                    <li><a href="#project" className="scroll">Project</a></li>
                    <li><a href="#contact" className="scroll">Contact</a></li>
                </ul>
            </nav>
            <div className="clearfix"></div>
        </header>
    )
}

export default Navbar;

